<template>
  <section>
    <div class="container">
      <h2>Here's The Breakdown!</h2>
      <div class="cta">
        <div class="module">
          <img class="icon" src="~assets/images/PFK_Icon_Shirt.svg" width="120" height="120">
          <h4>£10</h4>
          <p>Cost of School Uniforms</p>
        </div>
        <div class="module">
          <img class="icon" src="~assets/images/PFK_Icon_PieChart.svg" width="120" height="120">
          <h4>&#8531;</h4>
          <p>Of Average Rural Family's income</p>
        </div>
      </div>
      <h2>Our Impact So Far...</h2>
      <div class="flex">
        <img class="icon" src="~assets/images/PFK_Icon_Backpack.svg" width="75" height="75">
        <h4 v-if="backpacks">{{ backpacks | commafy }}</h4>
        <h4 v-else>XXXXX</h4>
        <p>Backpacks given in Myanmar</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'breakdown',
  props: ['backpacks', 'countries'],
  filters: {
    commafy (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~assets/styles/vars';

  section {
    padding: 80px 0;
  }

  h2 {
    text-align: center;
  }

  .flex {
    margin: 30px auto 0;
    display: block;
    text-align: center;
    @include media('tablet') {
      text-align: inherit;
      display: flex;
      align-items: center;
      width: 510px;
    }
    h4 {
      margin: 0 25px 0 15px;
    }
  }

  h4 {
    font-size: 4rem;
    color: $brand-primary;
    margin-bottom: 0;
    line-height: 1;
  }

  p {
    margin: 0.5rem 0 0;
    text-transform: uppercase;
    font-weight: 900;
    letter-spacing: 1px;
    font-size: 1.25rem;
    line-height: 1.25;
  }

  .container {
    @include media('tablet-wide') {
      width: 640px;
    }
  }

  .cta {
    margin: 3rem auto 5rem;
    max-width: 920px;
    @include media('tablet') {
      display: flex;
      justify-content: space-around;
    }
    .module {
      width: 270px;
      text-align: center;
      position: relative;
      margin: auto;
      &:after {
        content: '=';
        font-family: $hand;
        font-size: 5rem;
        position: relative;
        line-height: 20px;
        height: 34px;
        color: $brand-primary;
        @include media('tablet') {
          position: absolute;
          top: 64%;
          transform: translateY(-50%);
          right: -40px;
        }
      }
      &:last-child {
        &:after {
          content: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Breakdown.vue?41fbd73c